// chatwoot-chat.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

declare global {
    interface Window {
        chatwootSettings: {
            hideMessageBubble: boolean;
            type: string;
            launcherTitle: string;
            locale: string;
        };
        chatwootSDK: {
            run: (config: { websiteToken: string; baseUrl: string }) => void;
        };
        $chatwoot: {
            toggle: (state?: 'open' | 'close') => void;
        };
    }
}

@Component({
    selector: 'app-chatwoot',
    template: '', // 这个组件不需要渲染任何内容
})
export class ChatwootComponent implements OnInit, OnDestroy {
    constructor(private router: Router) { }

    ngOnInit(): void {
        // 只在 /cs 路径下打开聊天窗口
        if (this.router.url === '/cs') {
            this.openChatwootOnReady();
        }
    }

    ngOnDestroy(): void {
        // 在组件销毁时移除事件监听器
        window.removeEventListener('chatwoot:ready', this.openChatWindow);
        // 关闭聊天窗口
        if (window.$chatwoot) {
            window.$chatwoot.toggle('close');
        }
    }

    private openChatwootOnReady(): void {
        // 如果Chatwoot已经加载完成，添加事件监听器
        window.addEventListener('chatwoot:ready', this.openChatWindow);

        // 如果Chatwoot已经准备好了，直接尝试打开聊天窗口
        if (window.$chatwoot) {
            this.openChatWindow();
        }
    }

    private openChatWindow = (): void => {
        // 短暂延迟以确保界面完全加载
        setTimeout(() => {
            if (window.$chatwoot) {
                window.$chatwoot.toggle('open');
            }
        }, 1000);
    }
}
